'use client';
import * as React from 'react';

var ContainerSize;
(function (ContainerSize) {
    ContainerSize["FULL"] = "full";
    ContainerSize["XXXLARGE"] = "3xl";
    ContainerSize["XXLARGE"] = "2xl";
    ContainerSize["XLARGE"] = "xl";
    ContainerSize["LARGE"] = "lg";
    ContainerSize["MEDIUM"] = "md";
    ContainerSize["SMALL"] = "sm";
})(ContainerSize || (ContainerSize = {}));
var defaultTheme = new Map();
defaultTheme.set("size-".concat(ContainerSize.FULL), "w-full px-3 mx-auto");
defaultTheme.set("size-".concat(ContainerSize.XXXLARGE), "w-full px-3 mx-auto bs-3xl:max-w-bs-3xl");
defaultTheme.set("size-".concat(ContainerSize.XXLARGE), "w-full px-3 mx-auto bs-2xl:max-w-bs-2xl bs-3xl:max-w-bs-3xl");
defaultTheme.set("size-".concat(ContainerSize.XLARGE), "w-full px-3 mx-auto bs-xl:max-w-bs-xl bs-2xl:max-w-bs-2xl bs-3xl:max-w-bs-3xl");
defaultTheme.set("size-".concat(ContainerSize.LARGE), "w-full px-3 mx-auto bs-lg:max-w-bs-lg bs-xl:max-w-bs-xl bs-2xl:max-w-bs-2xl bs-3xl:max-w-bs-3xl");
defaultTheme.set("size-".concat(ContainerSize.MEDIUM), "w-full px-3 mx-auto bs-md:max-w-bs-md bs-lg:max-w-bs-lg bs-xl:max-w-bs-xl bs-2xl:max-w-bs-2xl bs-3xl:max-w-bs-3xl");
defaultTheme.set("size-".concat(ContainerSize.SMALL), "w-full px-3 mx-auto bs-sm:max-w-bs-sm bs-md:max-w-bs-md bs-lg:max-w-bs-lg bs-xl:max-w-bs-xl bs-2xl:max-w-bs-2xl bs-3xl:max-w-bs-3xl");
var ContainerStyle = /** @class */ (function () {
    function ContainerStyle() {
        this.size = "";
        this.appendedClassNames = "";
    }
    ContainerStyle.prototype.build = function () {
        var style = "";
        if (defaultTheme.has("size-".concat(this.size))) {
            style += defaultTheme.get("size-".concat(this.size));
        }
        if (this.appendedClassNames !== "") {
            style += " " + this.appendedClassNames;
        }
        return style;
    };
    ContainerStyle.prototype.setSize = function (size) {
        this.size = size;
        return this;
    };
    ContainerStyle.prototype.appendClassNames = function (classNames) {
        this.appendedClassNames = classNames || "";
        return this;
    };
    return ContainerStyle;
}());

var styleBuilder = new ContainerStyle();
function Container(props) {
    var _a = props.size, size = _a === void 0 ? ContainerSize.MEDIUM : _a;
    var handleClick = function () {
        props.onClick && props.onClick();
    };
    var styleClassNames = styleBuilder.
        setSize(size).
        appendClassNames(props.appendClassNames).
        build();
    return (React.createElement("div", { onClick: handleClick, className: styleClassNames, style: props.style }, props.children));
}

export { Container, ContainerSize };
